import { NoteOffIcon } from './NoteOffIcon';

/**
 * author: Colton Wiscombe
 * id 9EE3CDDD-BFF7-4BCF-B07E-B120D646DE0D
 * name note-off
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-off.svg
 * tags
 */
export const StickyNoteOffIcon = NoteOffIcon;
export default StickyNoteOffIcon